import { formatNumber } from "@buildpy/core/lib/format";
import type { PlanUsage } from "@buildpy/core/modules/plan/usage-limit";

export const OVER_LIMIT_LABEL = "한도 넘음";

// 「넘은 N건도 고객에게 보냈습니다」 — 한도가 있고 넘었을 때만.
export const notifyOverNoteOf = (usage: PlanUsage): string | null => {
  const { used, limit, level } = usage.notify;
  if (level !== "over" || limit === null) return null;
  return `넘은 ${formatNumber(Math.max(0, used - limit))}건도 고객에게 보냈습니다. 무료 요금제는 넘은 건을 청구하지 않습니다.`;
};
